"use client";

import { Provider } from "jotai";
import { ReactNode } from "react";

// GlobalMenuState専用のProvider
// 通常のjotaiProviderと違い、リセットされない様にあえてしている（keyにuuidを使わない）。そのためJotaiProviderの中ではなく、外で実行している
export default function GlobalMenuProvider({ children }: { children: ReactNode }) {
  return <Provider>{children}</Provider>;
}
